import styled from "styled-components"

export const StyledUserPanelAllEvents = styled.div`
    width: 100%;
    height: 100%;
`